import { Drawer, List, Button, Divider, Typography, Empty, Tag, Tooltip, Badge } from 'antd';
import { ShoppingCartOutlined, DeleteOutlined, ArrowRightOutlined, LeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import "./cart.scss";
import { useNavigate } from 'react-router-dom';
import FlowType from '../../enums/flowType.enum';
import { addFlow } from '../../services/flow.service';
const { Text } = Typography;

const Cart = ({ 
  open, 
  setOpen, 
  selectedTests, 
  removeTest, 
}) => {


  // Calculate prices
  const subtotal = selectedTests.reduce((sum, test) => sum + (test.cost || 0), 0);
  const serviceFee = 0; // If you need to calculate service fee based on some logic
  const totalPrice = subtotal + serviceFee;

  // Custom close icon with left arrow
  const closeIcon = (
    <Button 
      className="drawer-back-button" 
      icon={<LeftOutlined />} 
      type="text"
    >
    </Button>
  );

  const navigate = useNavigate();

  const onCheckout = async () => {
    const flow = await addFlow({
      type: FlowType.CUSTOM_TEST, 
      forceNew: true,
      testAddOns: selectedTests.map(test => test._id)
    })
    navigate(`/flow/${FlowType.CUSTOM_TEST}/location/${flow._id}`)
  }

  const handleOpen = () => {
    setOpen(true);
  }

  return (
    <div className="cart">
    <Drawer
      className="cart-drawer"
      closeIcon={closeIcon}
      placement="right"
      push={false}
      open={open}
      onClose={() => {setOpen(false)}}
      title={
        <div className="cart-header">
            Your Custom Panel
        </div>
      }
      width={500}
      footer={
        <div className="cart-footer">
          <div className="cart-summary">
            <div className="summary-row">
              <Text>Subtotal</Text>
              <Text>${subtotal.toFixed(2)}</Text>
            </div>
            <div className="summary-row">
              <Text>
                Concierge Fee {" "}
                <Tooltip 
                  title="The concierge fee includes the required physician order to order your tests, blood draw coordination, and personalized report with your test results."
                  placement="top"
                >
                  <InfoCircleOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
                </Tooltip>
              </Text>
              <Text>${serviceFee.toFixed(2)}</Text>
            </div>
            <Divider style={{ margin: '12px 0' }} />
            <div className="summary-row total">
              <div className="summary-row-label">Total</div>
              <div className="summary-row-price">${totalPrice.toFixed(2)}</div>
            </div>
          </div>
          <Button 
            type="primary" 
            block 
            size="large"
            onClick={onCheckout}
            disabled={selectedTests.length === 0}
            icon={<ArrowRightOutlined />}
          >
            Schedule Blood Draw
          </Button>
        </div>
      }
    >
      {selectedTests.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div className="empty-cart">
              <Text>Your panel is empty</Text>
              <Text type="secondary">Add tests to create your custom panel</Text>
            </div>
          }
        />
      ) : (
        <List
          className="cart-items"
          itemLayout="horizontal"
          dataSource={selectedTests.reverse()}
          renderItem={test => (
            <List.Item
              className="cart-item"
              actions={[
                <Button 
                  type="text" 
                  icon={<DeleteOutlined />} 
                  onClick={() => removeTest(test)}
                  className="delete-button"
                />
              ]}
            >
              <List.Item.Meta
                title={
                  <div className="item-title">
                    {test.longName || test.name}
                    {/* {test.tests && test.tests.length > 1 && (
                      <Tag className="biomarker-count">
                        {test.tests.length} biomarkers
                      </Tag>
                    )} */}
                  </div>
                }
                description={
                  <div className="item-details">
                    {test.shortName && test.shortName !== test.longName && (
                      <Text type="secondary" className="short-name">
                        {test.shortName}
                      </Text>
                    )}
                    <Text className="item-price">${test.cost || 0}</Text>
                  </div>
                }
              />
            </List.Item>
          )}
        />
      )}
    </Drawer>

    <div className="cart-fab">
      <Badge count={selectedTests.length} offset={[-5, 5]}>
        <Button 
          type="primary" 
          shape="circle" 
          size="large"
          icon={<ShoppingCartOutlined />}
          onClick={handleOpen}
          className="cart-fab-button"
          disabled={selectedTests.length === 0}
        />
      </Badge>
    </div>

    </div>
  );
};

export default Cart;